import { STATUS } from "#candidate/constants"
import CandidateStatusDate from "./CandidateStatusDate"

export default function CandidateStatusOnBoard() {
	return (
		<CandidateStatusDate
			label={"Fecha de ingreso"}
			title="Fecha de ingreso"
			status={STATUS.ONBOARD}
			message="Selecciona la fecha de ingreso del candidato como nuevo colaborador"
		/>
	)
}
